module.exports = __webpack_public_path__ + "static/img/douyin.cb0b73e0.png";